//DefaultTable

import * as React from 'react';
import { useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box';
import { DataGrid, gridClasses, GridToolbar } from '@mui/x-data-grid';
import { Button } from 'reactstrap';
import { alpha, styled } from '@mui/material/styles';
import { useIntl } from 'react-intl';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import AppsRoundedIcon from '@mui/icons-material/AppsRounded';

const ODD_OPACITY = 0.2;

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
    [`& .${gridClasses.row}.even`]: {
        backgroundColor: theme.palette.grey[200],
        '&:hover, &.Mui-hovered': {
            backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
            '@media (hover: none)': {
                backgroundColor: 'transparent',
            },
        },
        '&.Mui-selected': {
            backgroundColor: alpha(
                theme.palette.primary.main,
                ODD_OPACITY + theme.palette.action.selectedOpacity,
            ),
            '&:hover, &.Mui-hovered': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    ODD_OPACITY +
                    theme.palette.action.selectedOpacity +
                    theme.palette.action.hoverOpacity,
                ),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: alpha(
                        theme.palette.primary.main,
                        ODD_OPACITY + theme.palette.action.selectedOpacity,
                    ),
                },
            },
        },
    },
}));



const keyField = 'etiquetaCore_Id';

export default function EtiquetasCore_Table(props) {
    const [pageSize, setPageSize] = React.useState(10);
    const [rows, setRows] = React.useState(props.data);
    const [sortModel, setSortModel] = React.useState([
        {
            field: 'nombre',
            sort: 'desc',
        },
    ]);
    const intl = useIntl();
    const navigate = useNavigate();
    const columns = [
        {
            field: keyField,
            headerName: 'ID',
            width: 90,
            type: 'number',
            hide: true
        },
        {
            field: 'producto',
            headerName: intl.formatMessage({ id: 'Producto' }),
            editable: false,
            width: 120,
        },
        {
            field: 'nombre',
            headerName: intl.formatMessage({ id: 'EtiquetaCore' }),
            editable: false,
            width: 220,
            renderCell: (params) => {
                return <strong>{params.row['nombre']}</strong>
            }
        },
        {
            field: 'carton',
            headerName: intl.formatMessage({ id: 'Carton' }),
            editable: false,
            width: 180,
        },
        {
            field: 'colilla',
            headerName: intl.formatMessage({ id: 'Colilla' }),
            editable: false,
            width: 180,
        },
        {
            field: 'tipoFruta',
            headerName: intl.formatMessage({ id: 'TipoFruta' }),
            editable: false,
            width: 120,
        },
        {
            field: 'color',
            headerName: intl.formatMessage({ id: 'Color' }),
            editable: false,
            width: 120,
        },
        {
            field: 'observaciones',
            headerName: intl.formatMessage({ id: 'Distintivo adicional' }),
            editable: false,
            width: 200,
        },
        {
            field: 'naturaleza',
            headerName: intl.formatMessage({ id: 'Naturaleza' }),
            editable: false,
            width: 120,
        },
        {
            field: 'variantes',
            headerName: intl.formatMessage({ id: 'Variantes' }),
            editable: false,
            width: 90,
            cellClassName: (params) => {
                var result = ''
                if (!params.row['variantes'] || params.row['variantes'] == 0) {
                    result = 'errorColumn'
                }
                return result;
            }
        },
        {
            field: 'habilitado',
            headerName: intl.formatMessage({ id: 'Habilitado' }),
            editable: false,
            width: 120,
            renderCell: (params) => {
                return (params.row['habilitado'] == true ? intl.formatMessage({ id: 'Habilitado' }) : intl.formatMessage({ id: 'Desabilitado' }))
            }
        },
        {
            field: 'actions',
            headerName: '',
            sortable: false,
            editable: false,
            filterable: false,
            align: 'center',
            width: 180,
            renderCell: (params) => {
                return (
                    <div>
                        <Tooltip arrow placement="top" title={intl.formatMessage({ id: "Variantes" })}>
                            <IconButton className="DarkTealButton GridButton" onClick={() => {
                                navigate('/EtiquetasCore/' + params.row[keyField] + '/Variantes');
                            }}>
                                <AppsRoundedIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Editar">
                            <IconButton className='DarkBlueButton GridButton' onClick={() => {
                                props.edit_onclick(params.row[keyField])
                            }}>
                                <EditIcon />
                            </IconButton>
                        </Tooltip>
                        {params.row["variantes"] > 0 || params.row["paletizados"] > 0 ?
                            <Tooltip arrow placement="top" title={intl.formatMessage({ id: "Existen elementos asociados a este item" })}>
                                <span>
                                    <IconButton disabled={params.row["variantes"] > 0 || params.row["paletizados"] > 0} className='DisabledButton GridButton'>
                                        <DeleteIcon />
                                    </IconButton>
                                </span>
                            </Tooltip> :
                            <Tooltip arrow placement="top" title={intl.formatMessage({ id: "Eliminar" })}>
                                <IconButton disabled={params.row["variantes"] > 0 || params.row["paletizados"] > 0} className='RedButton GridButton' onClick={() => {
                                    props.delete_onclick(params.row[keyField])
                                }}>
                                    <DeleteIcon />
                                </IconButton>
                            </Tooltip>}
                    </div>

                )
            },
        },

    ];
    const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({
        etiquetaCore_Id: false,
    });
    return (
        <div>
            <Toolbar>
                <div className="row" style={{ width: '100%' }}>
                    <div className="col">
                        
                    </div>
                </div>
                <Button className="AddButton" style={{ whiteSpace: 'nowrap' }} onClick={() => {
                    props.add_onclick()
                }}><AddIcon /> Agregar</Button>
            </Toolbar>
            <Box sx={{
                height: 600, width: '100%',
            }}>

                <StripedDataGrid
                    rows={rows}
                    columns={columns}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions={[10, 20]}
                    pagination
                    disableRowSelectionOnClick
                    getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                    }
                    getRowId={(row) => row[keyField]}
                    sortModel={sortModel}
                    onSortModelChange={(newSortModel) => setSortModel(newSortModel)}
                    slots={{ toolbar: GridToolbar }}
                    slotProps={{
                        toolbar: {
                            showQuickFilter: true,
                            quickFilterProps: { debounceMs: 500, placeholder: 'Buscar' },
                            printOptions: { disableToolbarButton: true },
                            csvOptions: { disableToolbarButton: false },
                        },
                    }}
                    componentsProps={{
                        pagination: {
                            labelRowsPerPage: intl.formatMessage({ id: 'Resultados por pagina' }),
                            labelDisplayedRows: ({ from, to, count }) => `${from} - ${to} ${intl.formatMessage({ id: 'de' })} ${count}`,
                        }
                    }}

                    columnVisibilityModel={columnVisibilityModel}
                    onColumnVisibilityModelChange={(newModel) =>
                        setColumnVisibilityModel(newModel)
                    }
                />
            </Box>
        </div>
    );
}
